module.exports = __webpack_public_path__ + "static/media/bell.86facacc.svg";